
// Vendor imports
const classNames = require('classnames')
const React = require('react')
const PropTypes = require('prop-types')
// Shared imports
const BemEntity = require('shared/bem')

const bem = BemEntity('SocialProviderButton')

function SocialProviderButton(props) {
  return React.createElement('a', {
    className: classNames(
      props.className,
      bem.block(props.providerId)
    ),
    onClick: props.onClick,
    'data-provider': props.providerId
  },
    React.createElement('div', {
      className: bem.element('icon', props.providerId)
    }),
    React.createElement('label', {
      className: bem.element('label')
    },
      props.providerName
    )
  )
}

SocialProviderButton.propTypes = {
  // Values
  className: PropTypes.string,
  providerId: PropTypes.string.isRequired,
  providerName: PropTypes.string.isRequired,
  // Callbacks
  onClick: PropTypes.func
}

module.exports = SocialProviderButton
